
import { defineComponent, ref, computed } from 'vue'

import { store } from '@/store'
import InputSelect from '@/components/inputs/InputSelect.vue'
import InputCheck from '@/components/inputs/InputCheck.vue'
import { searchLocations } from '@/services/map.service'
import { platform } from '@/api/tools'

import { Place, PlaceModel, Location } from '@/api/tripply/models'
import { GA } from '@/api/analytics'

interface ImportRow {
  columns: string[];
  query: string;
  name: string;
  included: boolean;
  loading: boolean;
  location: Location | null;
}

export default defineComponent({
  name: 'ImportPlaces',
  props: {
    routeId: {
      type: String,
      required: true
    }
  },
  components: { InputSelect, InputCheck },
  setup(props, { emit }) {

    const step = ref(0)
    const paste = ref('')
    const rows = ref<ImportRow[]>([])
    const colSetup = ref([])
    const isCompleted = ref(false)

    const includedRows = computed(() => rows.value.filter(row => row.included))
    const errorRows = computed(() => rows.value.filter(row => row.included && row.location == null))

    const places: Place[] = []

    const saving = ref(false)

    function onPaste() {
      rows.value = []
      paste.value.split('\n').forEach((row, i) => {
        if (row) {
          rows.value.push({
            columns: row.split('\t'),
            query: '',
            name: '',
            included: true,
            loading: true,
            location: null
          })
        }
      })
      step.value = 1
    }

    async function search () {
      step.value = 2
      rows.value.forEach(async row => {
        if (row.included) {
          row.columns.forEach((column, j) => {
            
            if (colSetup.value[j] == 1) { // If part of address
              row.query += column + ' '
            }
            if (colSetup.value[j] == 2) { // If name
              row.name += column + ' '
            }
          })
          const result = await searchLocations(row.query, 1)
          row.loading = false
          if (result.length) {
            row.location = result[0]
            if (row.name) row.location.name = row.name
            places.push(new PlaceModel(row.location))
          }
        }
      })    
      isCompleted.value = true  
    }

    async function save() {
      saving.value = true
      store.route.addPlaces(props.routeId, places)
      GA('add_place', { method: 'import', number: places.length })
      saving.value = false
      store.modal.hideModal('PlaceImporter')
    }

    function reset() {
      step.value = 0
      paste.value = ''
      colSetup.value = []
    }

    return { store, step, paste, onPaste, rows, colSetup, search, save, saving, isCompleted, errorRows, platform, includedRows, reset }
  }
})
